// src/components/ProductList.js
import React, { useEffect, useState } from 'react';
import { getAllProducts } from '../apis/productApi';

const ProductList = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const data = await getAllProducts();
        setProducts(data);
      } catch (error) {
        console.error('Failed to load products');
      }
    };

    fetchProducts();
  }, []);

  return (
    <div>
      <h2>Total Products: {products.length}</h2>
      <ul>
        {products.map(product => (
          <li key={product.id}>{product.title}</li>
        ))}
      </ul>
    </div>
  );
};

export default ProductList;
